import { reportDetailService } from '../../helpers/services/reportDetail.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const REPORT_DETAIL_MODULE = 'reportDetail';

// define action 
export const GET_ALL_REPORT_DETAILS = 'getAllReportDetails';
export const GET_REPORT_DETAIL = 'getReportDetail';
export const GET_REPORT_DETAIL_BY_REPORT_ID = 'getReportDetailByReportID';
export const UPDATE_REPORT_DETAIL = 'updateReportDetail';
export const CREATE_REPORT_DETAIL = 'createReportDetail';
export const UPDATE_REPORT_DETAIL_STATUS = 'updateReportDetailStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_REPORT_DETAIL_REQUEST = "getAllReportDetail";
const GET_ALL_REPORT_DETAIL_WITHOUT_PAGINATION_REQUEST = "getAllReportDetailWithoutPaginationRequest";
const GET_REPORT_DETAIL_REQUEST = "getReportDetail";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_REPORT_DETAILS]({ commit }, { filter }) {
        reportDetailService
            .getAllReportDetails(filter)
            .then(
                (result) => {
                    commit(GET_ALL_REPORT_DETAIL_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_REPORT_DETAIL]({ commit }, { id }) {
        await reportDetailService
            .getReportDetail(id)
            .then(
                (result) => {
                    commit(GET_REPORT_DETAIL_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    async [GET_REPORT_DETAIL_BY_REPORT_ID]({ commit }, { id }) {
        await reportDetailService
            .getReportDetailByReportID(id)
            .then(
                (result) => {
                    commit(GET_ALL_REPORT_DETAIL_WITHOUT_PAGINATION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_REPORT_DETAIL]({ commit }, { data }) {
        commit(REQUEST)
        reportDetailService
            .updateReportDetail(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('label.detail')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_REPORT_DETAIL]({ commit }, { data }) {
        commit(REQUEST)
        reportDetailService
            .createReportDetail(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('label.detail')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_REPORT_DETAIL_STATUS]({ dispatch }, { filter, data }) {
        reportDetailService
            .updateReportDetailStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_REPORT_DETAILS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Report-detail-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { processing: true };
    },
    [GET_ALL_REPORT_DETAIL_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                description: o.description,
                package: o.package,
                newReport: o.new_report,
                menuService: o.menu_service,
                isComplete: o.is_complete,
                reportDetailCheckPointLabel: o.report_detail_check_point_labels,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_ALL_REPORT_DETAIL_WITHOUT_PAGINATION_REQUEST](state, data) {
        let d = data.data

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                description: o.description,
                package: o.package,
                newReport: o.new_report,
                menuService: o.menu_service,
                isComplete: o.is_complete,
                reportDetailCheckPointLabel: o.report_detail_check_point_labels,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_REPORT_DETAIL_REQUEST](state, data) {
        let o = data.data


        state.details = {
            uuid: o.uuid,
            description: o.description,
            package: o.package,
            newReport: o.new_report,
            menuService: o.menu_service,
            isComplete: o.is_complete,
            reportDetailCheckPointLabel: o.report_detail_check_point_labels,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


